export const KIOSK_CONFIG_QUERY_KEY = ["kiosk-config"]
